<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-8">
        <Heading title="Sitemap" subTitle="AMP sitemap speeds up the discovery of AMP pages and reduces time to appear on the search results." targetPlan="pro" noFreeUsers />
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Sitemap URL</h2>
        <p class="font-weight-normal mb-0">Submit this AMP sitemap url to Google Search Console for better results.</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <Alert icon="IconMoodHappy" class="alert-info" v-if="['pro', 'plus'].includes(plan)">
              <p class="mb-0">Should you see any error while submitting the AMP Sitemap, please resbumit it a few minutes.</p>
            </Alert>

            <div v-if="['pro', 'plus'].includes(plan)">
              <label>URL</label>
              <p class="mb-0 font-weight-normal">https://{{shopObj.domain}}/a/sc/amp/sitemap.xml</p>
            </div>
            <Alert icon="IconBolt" class="alert-info mb-0" v-else>
              <p class="mb-0">Sitemap is available in Pro plan &amp; above.</p>
            </Alert>
          </div>
        </div>
        <div class="card bs mt-3">
          <div class="card-body">
            <ExternalLink href="https://search.google.com/search-console" text="Submit your AMP sitemap to Google Search Console" class="active" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState(['plan', 'shopObj'])
}
</script>
